// extracted by mini-css-extract-plugin
export default {"paginationWrapper":"pagination_paginationWrapper__s3SJQ"};